import { render, staticRenderFns } from "./TableTr.vue?vue&type=template&id=10c9c578&scoped=true"
import script from "./TableTr.vue?vue&type=script&lang=js"
export * from "./TableTr.vue?vue&type=script&lang=js"
import style0 from "./TableTr.vue?vue&type=style&index=0&id=10c9c578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9c578",
  null
  
)

export default component.exports